import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    padding: ['28px 24px 48px', '60px 0px 90px'],
  },
  hero: {
    marginBottom: ['40px', '90px'],
  },
  webinarContent: {
    margin: ['0 auto 77px', '0 auto 86px'],
    maxWidth: ['950px'],
  },
  webinarContentTitle: {
    color: 'black.100',
    textAlign: 'center',
    marginBottom: ['40px', '65px'],
  },
  webinarContentBody: {
    variant: 'text.bodyIntro',
  },
  authorsContainer: {
    justifyContent: 'space-between',
    maxWidth: ['250px', '1500px'],
    flexWrap: 'wrap',
    margin: ['0 auto 50px', '0 auto 150px'],
  },
  share: {
    marginBottom: ['90px'],
  },
  moreWebinarsTitle: {
    color: 'indigo.100',
    textAlign: 'center',
    marginBottom: ['40px', '75px'],
  },
  moreWebinarsGrid: {
    columnGap: [null, '40px', null, null, null, '74px'],
    rowGap: ['20px', '40px'],
    marginBottom: ['40px', '65px'],
  },
  watchMore: {
    margin: ['0px auto 0px'],
  },
};
